/* eslint-disable */
import { PluginContainerData, FileSource } from './common';
import { FileData_PDFSettings_ViewMode } from './plugin_file.enums';
export function fileData_PDFSettings_ViewModeFromJSON(object) {
    switch (object) {
        case 0:
        case 'NONE':
            return FileData_PDFSettings_ViewMode.NONE;
        case 1:
        case 'FULL':
            return FileData_PDFSettings_ViewMode.FULL;
        case 2:
        case 'MINI':
            return FileData_PDFSettings_ViewMode.MINI;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return FileData_PDFSettings_ViewMode.UNRECOGNIZED;
    }
}
export function fileData_PDFSettings_ViewModeToJSON(object) {
    switch (object) {
        case FileData_PDFSettings_ViewMode.NONE:
            return 'NONE';
        case FileData_PDFSettings_ViewMode.FULL:
            return 'FULL';
        case FileData_PDFSettings_ViewMode.MINI:
            return 'MINI';
        default:
            return 'UNKNOWN';
    }
}
const baseFileData = {};
export const FileData = {
    fromJSON(object) {
        const message = Object.assign({}, baseFileData);
        message.containerData =
            object.containerData !== undefined && object.containerData !== null
                ? PluginContainerData.fromJSON(object.containerData)
                : undefined;
        message.src =
            object.src !== undefined && object.src !== null ? FileSource.fromJSON(object.src) : undefined;
        message.name =
            object.name !== undefined && object.name !== null ? String(object.name) : undefined;
        message.type =
            object.type !== undefined && object.type !== null ? String(object.type) : undefined;
        message.size =
            object.size !== undefined && object.size !== null ? Number(object.size) : undefined;
        message.pdfSettings =
            object.pdfSettings !== undefined && object.pdfSettings !== null
                ? FileData_PDFSettings.fromJSON(object.pdfSettings)
                : undefined;
        message.mimeType =
            object.mimeType !== undefined && object.mimeType !== null
                ? String(object.mimeType)
                : undefined;
        message.path =
            object.path !== undefined && object.path !== null ? String(object.path) : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.containerData !== undefined &&
            (obj.containerData = message.containerData
                ? PluginContainerData.toJSON(message.containerData)
                : undefined);
        message.src !== undefined &&
            (obj.src = message.src ? FileSource.toJSON(message.src) : undefined);
        message.name !== undefined && (obj.name = message.name);
        message.type !== undefined && (obj.type = message.type);
        message.size !== undefined && (obj.size = message.size);
        message.pdfSettings !== undefined &&
            (obj.pdfSettings = message.pdfSettings
                ? FileData_PDFSettings.toJSON(message.pdfSettings)
                : undefined);
        message.mimeType !== undefined && (obj.mimeType = message.mimeType);
        message.path !== undefined && (obj.path = message.path);
        return obj;
    },
};
const baseFileData_PDFSettings = { viewMode: FileData_PDFSettings_ViewMode.NONE };
export const FileData_PDFSettings = {
    fromJSON(object) {
        const message = Object.assign({}, baseFileData_PDFSettings);
        message.viewMode =
            object.viewMode !== undefined && object.viewMode !== null
                ? fileData_PDFSettings_ViewModeFromJSON(object.viewMode)
                : FileData_PDFSettings_ViewMode.NONE;
        message.disableDownload =
            object.disableDownload !== undefined && object.disableDownload !== null
                ? Boolean(object.disableDownload)
                : undefined;
        message.disablePrint =
            object.disablePrint !== undefined && object.disablePrint !== null
                ? Boolean(object.disablePrint)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.viewMode !== undefined &&
            (obj.viewMode = fileData_PDFSettings_ViewModeToJSON(message.viewMode));
        message.disableDownload !== undefined && (obj.disableDownload = message.disableDownload);
        message.disablePrint !== undefined && (obj.disablePrint = message.disablePrint);
        return obj;
    },
};
//# sourceMappingURL=plugin_file.js.map